export const SessionManagementConstants = {
    Severity_Err: 'error',
    TECHNICAL_ERROR_ON_SESSIONS_LOAD: 'Technical error : Failed to fetch the sessions. Please contact Technical support for further assistance.'
};
